/* --- global matchMedia: false */

'use strict';
var $ = require('jquery');
var util = require('../../utils/util');
var ajax = require('../../utils/ajax');
var carousel = require('../../components/carousel');
var lazyload = require('../../utils/lazyload');
var videovimeo = require('../../utils/videovimeo');
var optiExperiment = require('../../components/optimizelyExperimentation');
const cookie = require('../../components/cookie');

import {debounce, throttle} from '../../components/custom-lodash';
import loadVideo from './video/youtube';
import {hideZoom, switchIndicator} from './util/image';
import 'jquery-zoom';

const config = require('../../config/config');
const mobileMQ = window.matchMedia(`(max-width: ${config.BREAKPOINTS.TABLET_MAX}px)`);

/**
 * @function
 * @description Re-order PDP image and video elements for mobile
 * @param {HTMLElement} container product-image-slick container
 */

const reOrderContainerForMobile = container => {
    if (container !== null && mobileMQ.matches) {
        const images = [...container.querySelectorAll('.thumb')];

        // set default index
        images.forEach((image, index) => {
            if (image.dataset.index === undefined) {
                image.dataset.index = index;
            }
        });

        // sort by index, negative index means last
        images.sort((a, b) => {
            const aIndex = Number(a.dataset.index);
            const bIndex = Number(b.dataset.index);
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            if (aIndex < bIndex) return -1;
            if (aIndex > bIndex) return 1;
            return 0;
        });

        // set new order
        images.forEach(image => container.appendChild(image));
    }
};

/**
 * @function
 * @description Hide preload image and init vimeo video
 * @param {HTMLElement} container product image container
 */

const hideImageAndInitVideo = container => {
    container.parents('.product-image-container').find('.product-image--preload').addClass('hidden');
    videovimeo.init();
};

/**
 * @description initialize the vertical and horizontal thumbnail carousel
 */

var initThumbCarousel = async function () {
    let $pdpMain = $('.pdp-main');
    const $productSlick = $('.product-image-slick');
    const $thumbnailContainer = $('.thumbnail-container-slider');
    const $productThumbnailSlick = $('.product-image-thumbnail-slick');
    const $imagesWrapper = $('.slick-container-inner');
    const $imagesContainer = $('.product-image-container');
    const $slidesCount = $productSlick.find('.grid-tile');
    const indicator = '<ul class="image-indicator"></ul>';
    const indicatorElement = '<li class="indicator-line"></li>';
    const showVerticalThumbnails = $thumbnailContainer.data('showVerticalThumbnails');

    const result = await optiExperiment.decideFeatureFlagVariation('pdp');
    let optionNumber = 0;

    // Expected value of variationKeyImageStacking is "treatment_X" where X is the option number
    if (result.variationKeyImageStacking) {
        const treatment = parseInt(result.variationKeyImageStacking.split('_')[1]);
        optionNumber = isNaN(treatment) ? 0 : treatment;
    }

    if (showVerticalThumbnails === true) {
        optionNumber = 1;
    }

    carousel.init();
    if ($productSlick.length > 0 && !$productSlick.hasClass('slick-initialized')) {
        reOrderContainerForMobile($productSlick[0]);
    }

    cookie.isAllowed('vimeo', async isAllowed => {
        if (!isAllowed) {
            $('.disallowed-cookie').removeClass('m-hidden');
            $imagesContainer.addClass('cookie-disabled');
        }
    });

    $imagesContainer.one('click', '.slick-arrow', function () {
        hideImageAndInitVideo($(this));
    });

    $imagesContainer.one('click', function () {
        hideImageAndInitVideo($(this));
    });

    $productSlick.one('touchstart', function () {
        hideImageAndInitVideo($(this));
    });

    $(window).ready(function () {
        $(this).one('scroll', function () {
            videovimeo.init();
        });
    });

    $(window).on('load', function () {
        $('.product-image--preload').addClass('hidden');
    });

    let productSlickOptions = {
        autoplay: false,
        infinite: false,
        arrows: false,
        rtl: document.documentElement.lang === 'ar' ? true : false,
        dots: false,
        dotsClass: 'slick-dots-custom',
        slidesToShow: $slidesCount.length,
        slideToScroll: 1,
        draggable: false,
        vertical: true,
        verticalScrolling: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    verticalScrolling: false,
                    vertical: false,
                    slidesToShow: 1,
                    arrows: true,
                    dots: true,
                    prevArrow: $('.slick-prev')[0],
                    nextArrow: $('.slick-next')[0]
                }
            }
        ]
    };

    // Options 1 and 3 have an additional carousel with the thumnail images
    if (optionNumber === 1 || optionNumber === 3) {
        $productThumbnailSlick.removeClass('initially-hidden');

        productSlickOptions = {
            ...productSlickOptions,
            asNavFor: '.product-image-thumbnail-slick',
            verticalScrolling: false,
            vertical: false,
            slidesToShow: 1,
            arrows: true,
            prevArrow: $('.slick-prev')[0],
            nextArrow: $('.slick-next')[0]
        };

        $productThumbnailSlick.not('.slick-initialized').slick({
            vertical: optionNumber === 1 ? true : false,
            infinite: false,
            slidesToShow: 6,
            slideToScroll: 1,
            asNavFor: '.product-image-slick',
            focusOnSelect: true,
            prevArrow:
                '<button class="slick-prev slick-arrow" aria-label="Previous"><i class="icon icon-arrow_left" aria-hidden="true"></i></button>',
            nextArrow:
                '<button class="slick-next slick-arrow" aria-label="Next"><i class="icon icon-arrow_right" aria-hidden="true"></i></button>'
        });

        $imagesWrapper.addClass('m-thumbnails-enabled m-active-state-1');
        $pdpMain.addClass('m-image-indicator-disabled m-show-desktop-slider-controls');
    }

    // Option 1 is the vertical carosel and 3 is the horizontal one
    if (optionNumber === 1) {
        $imagesWrapper.addClass('m-thumbnails-left');
    } else if (optionNumber === 3) {
        $imagesWrapper.addClass('m-thumbnails-bottom');
        $thumbnailContainer.addClass('m-image-thumbnails-bottom');
    }

    $productSlick.not('.slick-initialized').slick(productSlickOptions);
    $productSlick.slick('setPosition'); // recalculate width and height

    // Option 2 is the two columns image stacking
    if (optionNumber === 2) {
        $pdpMain.addClass('m-two-images-in-row m-image-indicator-disabled');

        // if the number of images is odd we display the last three images in a single row
        var $slides = $productSlick.find('.slick-slide');
        if ($slides.length > 3 && $slides.length % 2 === 1) {
            $slides.slice(-3).addClass('m-three-in-row');
        }
    }

    if ($slidesCount.length <= 1) {
        if ($('.image-indicator').length > 0) {
            $('.image-indicator').html('');
        }
        return;
    }

    if ($('.image-indicator').length <= 0) {
        $pdpMain.append(indicator);
    }

    $('.image-indicator').html('');

    $slidesCount.each(function () {
        $('.image-indicator').append(indicatorElement);
    });

    var $imageIndicatorWrapper = $('.image-indicator');
    var $imageIndicatorItems = $('.image-indicator li');
    if (!$imageIndicatorItems.hasClass('active')) {
        $imageIndicatorItems.first().addClass('active');
    }

    $productSlick.slick('setPosition'); // recalculate width and height

    $imageIndicatorItems.on('click', function () {
        var index = $imageIndicatorItems.index(this);
        var $targetElement = $('.slick-slide').eq(index);

        $('html, body').animate(
            {
                scrollTop: $targetElement.offset().top
            },
            550
        );

        $imageIndicatorItems.removeClass('active');
        $imageIndicatorItems.eq(index).addClass('active');
    });

    $(window).on(
        'scroll touchmove',
        throttle(function () {
            var windowWidth = $(window).width();
            if (windowWidth > 1023) {
                var slickListHeight = $('.slick-list').height();
                var indicatorHeight = $imageIndicatorWrapper.height();
                var destination = slickListHeight - indicatorHeight - 100;
                var indicatorTop = $imageIndicatorWrapper.offset().top;
                var indicatorBottom = indicatorTop + indicatorHeight;
                var windowPos = window.pageYOffset;

                if (destination > windowPos) {
                    if (windowWidth <= Breakpoints.TabletLarge && windowWidth > Breakpoints.Tablet) {
                        $imageIndicatorWrapper.css({
                            position: 'fixed',
                            top: '30%'
                        });
                    } else if (windowWidth <= Breakpoints.Tablet) {
                        $imageIndicatorWrapper.css({
                            position: 'fixed',
                            top: '20%'
                        });
                    } else {
                        $imageIndicatorWrapper.css({
                            position: 'fixed',
                            top: '40%'
                        });
                    }
                }

                if ($imageIndicatorWrapper.offset().top > destination) {
                    $imageIndicatorWrapper.css({
                        position: 'absolute',
                        top: destination
                    });
                }

                var topPosition = $(window).scrollTop() + $('header').height();
                $('.slick-slide').each(function (index) {
                    if (topPosition + $(this).height() / 2 >= $(this).offset().top) {
                        $imageIndicatorItems.removeClass('active');
                        $imageIndicatorItems.eq(index).addClass('active');
                    }
                });
            }
        }, 50)
    );

    $productSlick.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        var $videoSlide = $(slick.$slides.get(currentSlide)).find('.product-image-overlay');

        if ($videoSlide.length > 0 && !$videoSlide.is(':visible')) {
            $videoSlide.show();
        }
    });
};

/**
 * @description opens zoom
 * @param img, target
 */
var showZoom = function ($triggerdImgZoom) {
    var $imgZoom = $triggerdImgZoom === undefined ? $('#pdpMain .main-image') : $triggerdImgZoom;
    var $target = $('#pdpMain .product-images-top').find('#zoom-overlay');
    var $overlayZoomImage = $target.find('.product-zoom-image');
    var hiresUrl;
    var magnification = 0.75;

    if (!$imgZoom.length) {
        // remove zoom
        $overlayZoomImage.trigger('zoom.destroy');
        return;
    }

    hiresUrl = $imgZoom.closest('a').attr('href');

    // use main image as fallback
    if (hiresUrl === undefined) {
        hiresUrl = $('.main-image .primary-image').attr('src');
        magnification = 2;
    }

    $overlayZoomImage.trigger('zoom.destroy');

    // exchange background zoom image with actual triggered zoom image
    $('.zoom-background-image').attr('src', hiresUrl);

    $target.show(400, function () {
        if (hiresUrl && hiresUrl !== 'null' && hiresUrl.indexOf('noimagelarge') === -1) {
            $overlayZoomImage.zoom({
                url: hiresUrl,
                magnify: magnification,
                callback: function () {
                    if (util.isFirefox()) {
                        $(this).trigger('mouseenter').trigger('mousemove');
                    }
                },
                onZoomIn: function () {
                    $('.zoom-background-image').hide();
                },
                onZoomOut: function () {
                    $('.zoom-background-image').show();
                    hideZoom();
                }
            });
        }
    });

    $('.product-zoom.zoom-out-link').removeClass('inactive');
    $('.product-zoom.zoom-in-link').addClass('inactive');

    // set addition close handler
    $('.product-zoom-image').on('click', function (e) {
        e.preventDefault();

        if ($target.is(':visible')) {
            hideZoom($target);
        }
    });

    $('.zoom-out-link')
        .not('.inactive')
        .on('click', function (e) {
            e.preventDefault();

            if ($target.is(':visible')) {
                hideZoom();
            }
        });
};

/**
 * @description Initialize zoom function (desktop)
 */
var initProductZoom = function () {
    var $zoomImage = $('.product-image-zoom');
    var zoomSrc = $zoomImage.attr('href');
    var $controllsZoom = $('#pdpMain .product-images-top').find('.image-controlls .product-zoom');

    // keep magnification 1 as long we use pdpzoom image size in transformobject in
    // productimages.isml and productthumbnails-carousel-include-2.isml, target resolution 1500x1500px
    var magnification = 1;

    // use main image as fallback
    if (zoomSrc === undefined) {
        zoomSrc = $zoomImage.children('.main-image').attr('src');
        magnification = 2;
    }

    $zoomImage.on('click', function (event) {
        event.preventDefault();
    });

    $controllsZoom.on('click', function (event) {
        event.preventDefault();
    });

    $zoomImage.zoom({
        url: zoomSrc,
        magnify: magnification,
        callback: function () {
            $controllsZoom.show();
        },
        onZoomIn: function () {
            $controllsZoom.hide();
        },
        onZoomOut: function () {
            $controllsZoom.show();
        },
        touch: false
    });
};

/**
 * @description Set zoom image and zoom handler for PDP images
 * @param img
 */
var initProductZoomMobile = function () {
    var $zoomOverlay = $('#pdpMain .product-images-top').find('#zoom-overlay');
    var $mainImage = $('#pdpMain .product-images-top').find('img.main-image');

    if ($zoomOverlay === undefined || $mainImage === undefined || $mainImage.hasClass('no-image')) {
        $('a.product-zoom').remove();
        return false;
    }

    // resize zoom overlay for desktop to cover top content section
    // $zoomOverlay.width($topContent.outerWidth());
    // $zoomOverlay.height($topContent.outerHeight());

    $('.product-image .main-image').unbind();

    var touchmoved = false;
    $('.product-image .main-image')
        .on('touchend', function (e) {
            e.preventDefault();

            if (!touchmoved) {
                if ($(this).hasClass('slider-image')) {
                    if (!$zoomOverlay.is(':visible')) {
                        showZoom($(this));
                    } else {
                        hideZoom();
                    }
                } else if (!$zoomOverlay.is(':visible')) {
                    showZoom();
                } else {
                    hideZoom();
                }
            }
        })
        .on('touchmove', function () {
            touchmoved = true;
        })
        .on('touchstart', function () {
            touchmoved = false;
        });

    $('.pdp-slider .bubble').on('touchstart', function () {
        hideZoom();
    });

    $('.zoom-in-link')
        .not('.inactive')
        .on('click', function (e) {
            e.preventDefault();

            if (!$zoomOverlay.is(':visible')) {
                showZoom();
            }
        });

    $('.carousel-container')
        .find('a.thumbnail-link')
        .on('click', function () {
            hideZoom();
        });

    $('.carousel-container').on('keydown', 'a.thumbnail-link', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).find('.productthumbnail').trigger('click');
        }
    });
};

/**
 * @description Request all product images asynchronously and init slider on them
 * @param {string} the product number
 */
var initMobileImageslider = function (pid) {
    var currentPid = pid || $('#pdpMain .product-primary-image').data('pid');
    var currentUrl = $('#pdpMain .product-primary-image').data('image-url');
    var url = currentUrl
        ? util.ajaxUrl(currentUrl)
        : util.appendParamToURL(util.ajaxUrl(Urls.getSliderImages), 'pid', currentPid);
    var $sliderContainer = $('#pdpMain .product-images-top').find('.main-image-slider .slider-images');
    var $defImageContainer = $('#pdpMain .product-images-top').find('.main-image-slider .default-image');
    ajax.load({
        url: url,
        target: $sliderContainer,
        callback: function () {
            carousel.init();
            initProductZoomMobile();
            $sliderContainer.show();
            $defImageContainer.hide();
            lazyload.init();

            var ytVideo = document.getElementById('yt-video');

            if (ytVideo) {
                var player;
                var videoId = $(ytVideo).find('.product-image-overlay-content').data('yt-id');

                if (!window.YT || !window.YT.Player) {
                    window.onYouTubeIframeAPIReady = function () {
                        new window.YT.Player('yt-' + videoId, {
                            height: '333',
                            width: '500',
                            videoId: videoId,
                            playerVars: {
                                autoplay: 1,
                                controls: 0,
                                loop: 1,
                                rel: 0,
                                modestbranding: 1,
                                enablejsapi: 1,
                                playsinline: 1,
                                origin: document.domain,
                                showinfo: 0
                            },
                            events: {
                                onReady: onPlayerReady
                            }
                        });
                    };
                } else {
                    new window.YT.Player('yt-' + videoId, {
                        height: '333',
                        width: '500',
                        videoId: videoId,
                        playerVars: {
                            autoplay: 1,
                            controls: 0,
                            loop: 1,
                            rel: 0,
                            modestbranding: 1,
                            enablejsapi: 1,
                            playsinline: 1,
                            origin: document.domain,
                            showinfo: 0
                        },
                        events: {
                            onReady: onPlayerReady
                        }
                    });
                }

                function toggleVideo(e) {
                    if (player.getPlayerState() === 1) {
                        player.pauseVideo();
                    } else {
                        player.playVideo();
                    }
                }

                function onPlayerReady(event) {
                    player = event.target;
                }

                ytVideo.addEventListener('click', toggleVideo, false);
            }
        }
    });
};

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
var setMainImage = function (atts) {
    if (!atts) {
        return;
    }

    $('#pdpMain .primary-image:not(.slider-main-image,.slider-image,.variant-image)').attr({
        src: atts.url,
        alt: atts.alt,
        title: atts.title
    });
};

/**
 * @description Sets the zoom image attributes
 * @param {Object} atts Object with url, alt, title, hires and zoom properties
 */
var setZoomImage = function (atts) {
    if (!atts) {
        return;
    }

    var $overlayZoomImage = $('#pdpMain .product-image-container').find('.product-zoom-image');
    var $zoomImage = $overlayZoomImage.find('img.zoom-image');
    var $mainImage = $('#pdpMain .product-images-top').find('img.main-image');

    $mainImage.trigger('zoom.destroy');

    if ($zoomImage !== undefined && $zoomImage.lenght !== 0) {
        $zoomImage.attr({
            src: atts.hires,
            alt: atts.alt,
            title: atts.title
        });

        initProductZoom();
    }
};

/**
 * @description Sets the main image, the href for the surrounding <a> tag and also the zoom image
 * @param {Object} atts Object with url, alt, title, hires and zoom properties
 */
var setProductImages = function (atts) {
    setMainImage(atts);
    setZoomImage(atts);
};

/**
 * @description Replaces the images in the image container, for eg. when a different color was clicked.
 */
var replaceImages = function () {
    var $newImages = $('#update-images');
    var $imageContainer = $('#pdpMain .product-image-container');
    if (!$newImages.length) {
        return;
    }

    $imageContainer.html($newImages.html());
    $newImages.remove();
    initThumbCarousel();
    initMobileImageslider();
    initProductZoom();
    loadVideo();
};

// Remove campaign-image from carousel
function removeCampaignImage() {
    var widthsize = $(window).width();
    if (widthsize > 1023) {
        $('.productthumbnail.campaign-image').parent().parent().remove();
    }
}

// Show share button only mobile or tablet
function showShareButton() {
    if (util.isMobile() || util.isTablet()) {
        $('.share-button').show();
    }
}

/**
 * Removes a slide from the carousel
 *
 * @param {JQuery} slideElement - and element initially rendered on the page
 */
function deleteSlide(slideElement) {
    const index = slideElement.parent().parent().data('slick-index');
    if (!index) {
        return;
    }
    const slider = $('.product-image-slick');
    slider.slick('slickRemove', index);
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 */

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 */
module.exports = function () {
    initProductZoom();

    // handle product thumbnail click event
    $('#pdpMain').on('click', '.productthumbnail', function () {
        switchIndicator($(this));
        hideZoom();
        setProductImages($(this).data('lgimg'));
    });

    initThumbCarousel();
    initMobileImageslider($('#pdpMain .product-primary-image').data('pid'));
    removeCampaignImage();
    loadVideo();

    $(window).on(
        'resize orientationchange',
        debounce(function () {
            $('.product-image-slick').slick('resize');
            showShareButton();
        }, 100)
    );
    if (navigator.share) {
        showShareButton();
        $('body').on('click touchstart', '.share-button', function () {
            $(this).trigger('focus');
            let sharingUrl = util.getSharingLink();
            navigator.share({
                title: document.title,
                url: sharingUrl
            });
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'shareIconClick',
                    ecomm_prodid: $('#pdpMain .product-primary-image').data('pid')
                });
            }
        });
    }
};

module.exports.initProductZoom = initProductZoom;
module.exports.setMainImage = setMainImage;
module.exports.replaceImages = replaceImages;
module.exports.initThumbCarousel = initThumbCarousel;
module.exports.deleteSlide = deleteSlide;
